import { render } from "./NoOutcome.vue?vue&type=template&id=4645f5b5&ts=true"
import script from "./NoOutcome.vue?vue&type=script&lang=ts"
export * from "./NoOutcome.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\BespokeRetirements.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__